import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['output', 'input', 'validationText', 'removeButton', 'default']
  static values = {
    scope: String,
    allowedTypes: { type: Array, default: ['image/jpeg', 'image/png'] }
  }

  declare readonly inputTarget: HTMLInputElement
  declare readonly outputTarget: HTMLInputElement
  declare readonly removeButtonTarget: HTMLButtonElement
  declare readonly validationTextTarget: HTMLInputElement
  declare readonly defaultTarget: HTMLElement
  declare readonly hasDefaultTarget: boolean
  declare readonly scopeValue: string
  declare readonly allowedTypesValue: string[]

  connect (): void {
    this.toggleRemoveButton()
    this.initializePlaceholderVisibility()
  }

  initializePlaceholderVisibility (): void {
    const placeholder = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    if (this.outputTarget.src !== placeholder && this.hasDefaultTarget) {
      this.defaultTarget.classList.add('hidden')
    }
  }

  readURL (): void {
    const file = this.inputTarget.files?.[0]
    const reader = new FileReader()

    if (!this.validate(file)) {
      return
    }

    this.outputTarget.hidden = false
    if (this.hasDefaultTarget) {
      this.defaultTarget.classList.add('hidden')
    }

    if (file === null || file === undefined) {
      return
    }

    reader.onload = () => {
      if (typeof reader.result === 'string') {
        this.outputTarget.src = reader.result
        this.toggleRemoveButton(false)
      }
    }

    reader.readAsDataURL(file)
  }

  toggleRemoveButton (disable?: boolean): void {
    const placeholder = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

    if (disable === undefined) {
      this.toggleRemoveButton(this.outputTarget.src === placeholder)
    } else {
      this.removeButtonTarget.classList.toggle('disabled', disable)
    }
  }

  hideOutput (): void {
    this.toggleRemoveButton(true)
    this.outputTarget.hidden = true
    if (this.hasDefaultTarget) {
      this.defaultTarget.classList.remove('hidden')
    }
    this.inputTarget.value = ''
  }

  validate (file: File | undefined): boolean {
    const validationText = this.validationTextTarget

    if (file == null) {
      return false
    }

    const maxSizeStr = this.inputTarget.dataset.maxSize
    const maxSize = maxSizeStr !== undefined ? Number(maxSizeStr) : 2

    if (file.size > maxSize * 1024 * 1024 || !this.allowedTypesValue.includes(file.type)) {
      validationText.classList.add('text-stm-error-solid')
      return false
    }

    validationText.classList.remove('text-stm-error-solid')
    return true
  }
}
